import { render, staticRenderFns } from "./adress.vue?vue&type=template&id=12d16566&scoped=true&"
import script from "./adress.vue?vue&type=script&lang=js&"
export * from "./adress.vue?vue&type=script&lang=js&"
import style0 from "./adress.vue?vue&type=style&index=0&id=12d16566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d16566",
  null
  
)

export default component.exports